import React from 'react';

function AspectRatio({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 18"
      {...otherProps}
    >
      <g strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-191, -438)">
          <g transform="translate(190, 435)">
            <rect width="24" height="24" />
            <g transform="translate(2, 4)">
              <rect strokeWidth="1.3" width="20" height="16" rx="2" />
              <path d="M7,11 L3,5" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M7,5 L3,11" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M15,8 L13,5"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15,8 L15,11"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17,5 L15,8"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle fill="#000" cx="10" cy="9.85" r="0.5" />
              <circle fill="#000" cx="10" cy="6" r="0.5" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AspectRatio;
